import { z } from "zod";

const formAddClanicaUMSchema = z.object({
  clanicaID: z
    .number()
    .nullable()
    .refine((val) => val !== null, {
      message: "Izberite članico",
    }),

  vlogaID: z
    .number()
    .nullable()
    .refine((val) => val !== null, {
      message: "Izberite vlogo članice",
    }),

  osebaSelected: z
    .object({
      value: z.number(),
      label: z.string(),
    })
    .nullable()
    .refine((data) => data !== null, {
      message: "Izberite kontaktno osebo",
    }),

  skrbnik: z.boolean(),
});

export default formAddClanicaUMSchema;
